// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveyView_container__2EfL0","loaderContainer":"SurveyView_loaderContainer__2UDn9","closeButton":"SurveyView_closeButton__1cEnv"};